"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('debug', {
    showError: function (msg) {
        if (namespace_1.default.params.debug) {
            if (typeof console !== "undefined") {
                if (typeof console.log !== "undefined") {
                    console.error('ERROR: ' + msg);
                }
            }
        }
    },
    showInfo: function (msg) {
        if (namespace_1.default.params.debug) {
            if (typeof console !== "undefined") {
                if (typeof console.log !== "undefined") {
                    console.log('INFO: ' + msg);
                }
            }
        }
    }
});
